module.exports = "<symbol id=\"tt-icon-bell\" viewBox=\"0 0 24 24\"><path d=\"M4.25 17.19h15.5a7 7 0 0 1-2.56-5.4V8.1a5.19 5.19 0 0 0-10.38 0v3.69a7 7 0 0 1-2.56 5.4zm19.44 2.6H.31v-3.53L1.2 16a4.39 4.39 0 0 0 3-4.17V8.1a7.79 7.79 0 0 1 15.58 0v3.69a4.39 4.39 0 0 0 3 4.17l.89.3zm-16.16 1.3h8.94a5.14 5.14 0 0 1-8.94 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page/bell.svg
// module id = 177
// module chunks = 11